import { Injectable } from '@angular/core';
import { from, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import {
  RouteEventsStorageHelper,
  VisitedUrl,
} from './route-events-storage-helper';
import { CurrentUserService } from './current-user.service';

@Injectable({
  providedIn: 'root',
})
export class RouteEventsStorageService {
  setRecentUrlSubscription$?: Subscription;
  constructor(private currentUserService: CurrentUserService) {}

  public setRecentUrl(urlVal: VisitedUrl) {
    this.setRecentUrlSubscription$ = this.currentUserService.aptitudeUser$
      .pipe(take(1))
      .subscribe((currentUser) => {
        const {
          userId,
          organization: { id: orgId },
        } = currentUser;
        RouteEventsStorageHelper.setLocalForageItem(urlVal, {
          userId,
          orgId,
        });
      });
  }

  public getRecentUrls() {
    return this.currentUserService.aptitudeUser$.pipe(
      switchMap((currentUser) => {
        const {
          userId,
          organization: { id: orgId },
        } = currentUser;

        return from(
          RouteEventsStorageHelper.getLocalForageItem({
            userId,
            orgId,
          }),
        );
      }),
    );
  }

  ngOnDestroy(): void {
    this.setRecentUrlSubscription$?.unsubscribe();
  }
}
